import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "memorium-admin-token";

export const adminApi = (token) =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });

export const fileUrl = (path) => `${API}/files/${path}`;

export const formatBytes = (n) => {
  if (!n) return "0 Mo";
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  if (n < 1024 ** 3) return `${(n / 1024 / 1024).toFixed(1)} Mo`;
  return `${(n / 1024 ** 3).toFixed(2)} Go`;
};

export const field =
  "w-full rounded-xl border border-stone-200 bg-white px-4 py-3 text-sm text-stone-800 placeholder:text-stone-400 focus:border-[#C5A059] focus:outline-none focus:ring-2 focus:ring-[#C5A059]/30";

export const darkBtn =
  "inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#1C1917] px-5 py-2.5 text-xs font-semibold text-[#FAF8F5] transition-colors duration-300 hover:bg-[#C5A059] hover:text-[#1C1917] disabled:opacity-40";

export const ghostBtn =
  "inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full border border-stone-300 px-4 py-2 text-xs font-semibold text-stone-600 transition-colors duration-300 hover:border-[#C5A059] hover:text-[#8a6b2e] disabled:opacity-40";
